import React from "react";
import Button from "storybookComponents/Button";
import { isValidatedCSV, getBase64 } from "../utils";

const UploadBox = ({ classes, onUpload, disabled, showNotification }) => {
  const uploadInputRef = React.useRef();

  const openFileInput = () => uploadInputRef.current.click();

  const handleChange = async (e) => {
    if (e.target.files.length > 0) {
      isValidatedCSV(e.target.files[0])
        .then((file) => {
          getBase64(file)
            .then((base64) => {
              onUpload(base64, file.name);
            })
            .catch((error) => {
              showNotification(error.message || "Something went wrong!", "error");
            });
        })
        .catch((err) => showNotification(err.message, "error"));
    }
  };

  return (
    <div className={classes.subContentBox} style={{ flexFlow: "column" }}>
      <div>
        <div className={classes.subContentHead}>Upload Broker CSV file</div>
        <div className={`${classes.text2} ${classes.marginStyle}`}>
          Select .CSV file (less than 10MB) for successful import
        </div>
      </div>
      <Button
        className={classes.btnStyle}
        onClick={openFileInput}
        state={disabled ? "inactive" : ""}
      >
        Upload CSV
      </Button>
      <input
        ref={uploadInputRef}
        type="file"
        onChange={handleChange}
        style={{ display: "none" }}
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      />
    </div>
  );
};

export default UploadBox;
